import { SECONDS_IN_MINUTE } from '../constants/time';
// formatCountdownTime(125, 'min', 's') -> "2 min 5 s"
// formatCountdownTime(65, 'min', 'sec') -> "1 min 5 sec"
export const formatCountdownTime = (totalSeconds, minuteLabel, secondLabel) => {
    const minutes = Math.floor(totalSeconds / SECONDS_IN_MINUTE);
    const seconds = totalSeconds % SECONDS_IN_MINUTE;
    return `${minutes} ${minuteLabel} ${seconds} ${secondLabel}`;
};
